var map = {
	"./Amuses bouches.jpg": 8974,
	"./Brownies.jpg": 318,
	"./Cakes aux légumes.jpg": 1216,
	"./Champignon mexicain.jpg": 3907,
	"./Chasse aux champignons.jpg": 8129,
	"./Chasse aux chanterelles.jpg": 940,
	"./Chasse aux cèpes.jpg": 7295,
	"./Classique tomate basilic.jpg": 6338,
	"./Crème de potimarron.jpg": 7096,
	"./Crème vegan et confiture.jpg": 4505,
	"./Cube de bouillon de légume.jpg": 2203,
	"./Cuisine pour le Playfight.jpg": 9170,
	"./Curry d'aubergine.webp": 6691,
	"./Curry pois chiches.jpg": 1236,
	"./Dahl aux tomates.jpg": 3547,
	"./Dalh indien.jpg": 7981,
	"./Du jardin à l'assiette.jpg": 7819,
	"./Entrée - Salade.jpg": 8831,
	"./Feuilles de vigne et Berek.jpg": 7758,
	"./Galette des rois 5cm de haut.jpg": 2600,
	"./Gaspacho de betterave à l'huile de figue.jpg": 9177,
	"./Gratinssss.jpeg": 8647,
	"./Gyozas vegans aux champignons et aubergines 1.jpg": 9562,
	"./Gyozas vegans aux champignons et aubergines 2.jpg": 7413,
	"./Haricot vert Turc.jpg": 1832,
	"./Houmous de betterave.jpg": 3146,
	"./Kamil au Playfight.jpg": 1027,
	"./La compote de pêche de Kamil.JPG": 6738,
	"./Méga coulemelle.jpg": 6652,
	"./Méga cèpe.jpg": 2757,
	"./Nouilles vietnamiennes.jpg": 3450,
	"./Oeufs marinés.jpg": 962,
	"./Oranges marinées au miel avec du Toum.jpg": 3906,
	"./Orecchiette à l'ortie.jpg": 8408,
	"./Painted clementines.jpg": 9179,
	"./Patate tout simplement.jpg": 9996,
	"./Pesto d'ortie 2.jpg": 9564,
	"./Pesto d'ortie 3.jpg": 1177,
	"./Pesto d'ortie.jpg": 1254,
	"./Petit déjeuner des champions.jpg": 9697,
	"./Pickles en préparation.jpg": 9350,
	"./Pizza night.jpg": 3619,
	"./Poivron à la feta.jpg": 805,
	"./Poivron à la mexicaine.jpg": 4824,
	"./Racines de poireaux.jpg": 4344,
	"./Ramen.jpg": 9290,
	"./Risotto aux champignons frais.jpg": 4605,
	"./Risotto aux champignons.jpg": 7688,
	"./Rouleau de courgette à la feta.jpg": 608,
	"./Rouleaux de pintemps 2.jpg": 1567,
	"./Rouleaux de printemps.jpg": 2311,
	"./Salade Turc.jpg": 5627,
	"./Salade de betterave 2.jpg": 6136,
	"./Salade de betterave.jpg": 2226,
	"./Salade de choux.jpg": 1893,
	"./Salade de courgette.jpg": 5378,
	"./Salade de graines germées.jpg": 5659,
	"./Service nature.jpg": 6213,
	"./Soupe asiatique de choux-fleur.jpg": 9932,
	"./Super cèpes.jpg": 93,
	"./Sushis vegans.jpg": 1494,
	"./Tarte aux plantes et fleurs sauvages.jpg": 381,
	"./Tartinade aux plantes sauvages.jpg": 7031,
	"./Tour de fruit handmade.jpg": 264,
	"./Vegetable love.jpg": 2132
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2508;